/**
 * Função auxiliar para verificar sobreposição entre dois intervalos de data e
 * hora semi-abertos [A, B) e [C, D).
 * Conflito ocorre se A < D E C < B.
 *
 * Sobreposições:
 *   A---B     A---B       A---B     A-B
 * C---D         C---D      C-D     C---D
 *
 * @param {Date} visitStart
 * @param {Date} visitEnd
 * @param {Date} restStart
 * @param {Date} restEnd
 * @returns {boolean} True se houver sobreposição.
 */
const intervalsOverlap = (visitStart, visitEnd, restStart, restEnd) => {
  // Sobrecarga se o início de um for antes do fim do outro E o início do outro
  // for antes do fim do primeiro.
  return visitStart.getTime() < restEnd.getTime() && restStart.getTime() < visitEnd.getTime();
};

export { intervalsOverlap };
